/** Alta breve de cliente en campo (Yup, con su test; contrato ClientCreate).
 *
 * El RUC sigue la regla de la web: 11 digitos con digito de control peruano
 * valido (`utils/peruRuc.ts`). El mensaje nombra la causa para indicar que
 * corregir.
 */
import * as yup from 'yup';
import { peruRucError } from '@/utils/peruRuc';

export const mobileClientSchema = yup.object({
  legal_name: yup
    .string()
    .required('La razon social es obligatoria')
    .trim()
    .min(2, 'La razon social es muy corta')
    .max(255, 'La razon social es muy larga'),
  tax_id: yup
    .string()
    .required('El RUC es obligatorio')
    .transform((value) => (typeof value === 'string' ? value.trim() : value))
    .test(
      'ruc-peruano',
      'Ingresa 11 digitos, solo numeros',
      function rucTest(value) {
        const message = peruRucError(value);
        if (message === undefined) return true;
        return this.createError({ message });
      },
    ),
  business_name: yup.string().trim().max(255, 'El nombre comercial es muy largo').default(''),
});

export type MobileClientForm = yup.InferType<typeof mobileClientSchema>;
